import type { ReactNode } from 'react';

export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-14 px-6 text-center border border-dashed border-border-soft rounded-xl bg-soft/60">
      {icon && <div className="mb-3 text-text-4">{icon}</div>}
      <h3 className="font-bold text-text-1">{title}</h3>
      {description && <p className="text-sm text-text-3 mt-1.5 max-w-md">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
